import React, { FunctionComponent } from "react";

import { ButtonBackgroundColor, IconSelectItem, IconTextButton, Select, SelectBody } from "@multiweb/reactComponents";
import { doNothing } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";

export type SetSettingsDropdownSelectComponentProps = {
    readonly openSetEditDialog: () => void;
    readonly deleteSet: () => void;
    readonly editText: string;
    readonly deleteText: string;
    readonly printText: string;
    readonly setText: string;
    readonly setSettingsText: string;
};

// Select vyextrahován do samotného souboru, ať ToolbarPanel.tsx není tak dlouhý...
// Stejně se mi ten select nezdá, nejde jednoduše přiřadit funkce při kliku na talčítko, aniž by se nevyskytlo nežádoucí chování.
export const SetSettingsDropdownSelectComponent: FunctionComponent<SetSettingsDropdownSelectComponentProps> = ({
    openSetEditDialog,
    deleteSet,
    editText,
    deleteText,
    printText,
    setText,
    setSettingsText,
}) => {
    const handleOnOpenEditDialogClick = (onSelect: (value: string) => void) => {
        onSelect("upravit");
        openSetEditDialog();
    };

    const handleOnDeleteSetClick = (onSelect: (value: string) => void) => {
        onSelect("smazat");
        deleteSet();
    };

    const handleOnPrintClick = (onSelect: (value: string) => void) => {
        onSelect("tisk");
    };

    return (
        <Select
            onChange={doNothing}
            value={undefined}
            options={[
                { text: editText, value: "upravit" },
                { text: deleteText, value: "smazat" },
                { text: printText, value: "tisk" },
            ]}
            optionsContent={({ opened, onSelect }) => {
                return (opened &&
                    <SelectBody>
                        <IconSelectItem iconCode={IconCode.editorialPencil} onSelect={() => handleOnOpenEditDialogClick(onSelect)} text={editText} />
                        <IconSelectItem iconCode={IconCode.editorialTrash} onSelect={() => handleOnDeleteSetClick(onSelect)} text={deleteText} />
                        <IconSelectItem iconCode={IconCode.docPrinter} onSelect={() => handleOnPrintClick(onSelect)} text={printText} />
                    </SelectBody>
                );
            }}
            selectedOptionContent={({ opened, setOpened }) => (
                <IconTextButton outline={false} iconCode={IconCode.settings} onClick={() => setOpened(!opened)} value={setText} title={setSettingsText} backgroundColor={ButtonBackgroundColor.transparent} />
            )}
        />
    );
};
